export const environment = {
  production: true,
  BASE_DOMAIN:'https://ptl.apollosupplychain.com/',
  AUTH_URL:'https://ptl.apollosupplychain.com/auth-service-common/',
  New_BASE_DOMAIN:'https://ptl.apollosupplychain.com/',
  COOKIE_DOMAIN: 'localhost',
  ORDER_URL: 'https://ptl.apollosupplychain.com/',
  WebsocketUrl: 'wss://ptl.apollosupplychain.com/websocket-service/ws/notifications'
};
